// apps/web/src/components/visitors/VisitorCard/modes/TableMode.tsx
import React from 'react';
import { TableRow, TableCell, Box, Typography } from '@mui/material';
import { CalendarToday as CalendarIcon } from '@mui/icons-material';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { Visitor, ActiveSubscriptionInfo } from '@gym-management/shared';
import CompactMode from './CompactMode';
import VisitorActions from '../VisitorActions';

interface TableModeProps {
  visitor: Visitor;
  isCheckedIn: boolean;
  hasActiveSubscription?: boolean;
  activeSubscription?: ActiveSubscriptionInfo;
  size?: 'small' | 'medium';
  onEdit?: (visitor: Visitor) => void;
  onDelete?: (id: string) => void;
  onViewDetails?: (visitor: Visitor) => void;
  onShowQR?: (visitor: Visitor) => void;
  onShowHistory?: (visitor: Visitor) => void;
  onCheckIn?: () => void;
  onCheckOut?: () => void;
}

const TableMode: React.FC<TableModeProps> = ({
  visitor,
  isCheckedIn,
  hasActiveSubscription,
  activeSubscription,
  onEdit,
  onDelete,
  onViewDetails,
  onShowQR,
  onShowHistory,
  onCheckIn,
  onCheckOut,
}) => {
  const formattedDate = format(new Date(visitor.createdAt), 'dd MMM yyyy', { locale: ru });

  return (
    <TableRow hover>
      <TableCell sx={{ width: { xs: '60%', sm: '50%', md: '40%' }, maxWidth: 500 }}>
        <CompactMode
          visitor={visitor}
          isCheckedIn={isCheckedIn}
          hasActiveSubscription={hasActiveSubscription}
          activeSubscription={activeSubscription}
          onViewDetails={onViewDetails}
        />
      </TableCell>
      <TableCell sx={{ width: 120, whiteSpace: 'nowrap' }}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <CalendarIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
          <Typography variant="body2">{formattedDate}</Typography>
        </Box>
      </TableCell>
      <TableCell align="right" sx={{ width: { xs: 140, sm: 160, md: 180 }, pr: 2 }}>
        <VisitorActions
          visitor={visitor}
          onEdit={onEdit}
          onDelete={onDelete}
          onViewDetails={onViewDetails}
          onShowQR={onShowQR}
          onShowHistory={onShowHistory}
          onCheckIn={onCheckIn}
          onCheckOut={onCheckOut}
          isCheckedIn={isCheckedIn}
          variant="table"
          size="small"
        />
      </TableCell>
    </TableRow>
  );
};

export default TableMode;
